export const Login = {
	title: "Logg inn",
	description: "Logg inn for å låse opp fremtidens hydrauliske plattform.",
	button_text: "Logg inn",
	button_text_loading: "Logger inn...",
	error_message: "Innlogging mislyktes. Prøv igjen senere.",
	forgot_password_link_text: "Glemt passord?",
	microsoft_sso_button_text: "Logg inn med Microsoft",
};
